import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { Button } from "@/components/ui/button";
import { ChevronLeft, ChevronRight } from "lucide-react";

const SommerCamps2025Page = () => {
  const navigate = useNavigate();
  const videoUrl = "https://www.youtube.com/embed/eK35plJy-Xc";

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleNavigateBack = () => {
    navigate('/');
    setTimeout(() => {
      const section = document.getElementById('ns7');
      if (section) {
        const offset = -80;
        const elementPosition = section.getBoundingClientRect().top;
        const offsetPosition = elementPosition + window.pageYOffset + offset;
        
        window.scrollTo({
          top: offsetPosition,
          behavior: "smooth"
        });
      }
    }, 100);
  };

  return (
    <div className="bg-gradient-to-r from-[#243949] to-[#517fa4]" id="kurzueberblick">
      <div className="container mx-auto px-4 py-8">
        <div className="flex items-center justify-between mb-8">
          <Button 
            variant="ghost" 
            className="text-white hover:bg-white/10 p-2 h-auto group"
            onClick={handleNavigateBack}
          >
            <div className="flex items-center animate-horizontal-bounce">
              <ChevronLeft className="w-4 h-4" />
              <ChevronLeft className="w-4 h-4 -ml-2" />
            </div>
          </Button>
          
          <h2 className="text-xl md:text-2xl text-white font-bold text-center uppercase flex-grow">
            2min-Kurzüberblick im Video
          </h2>
          
          <div className="w-[40px]"></div>
        </div>

        <div className="max-w-4xl mx-auto">
          {/* Video section moved to top */}
          <div className="flex flex-col items-center mb-8">
            <div className="w-full max-w-xl">
              <div className="bg-white/10 backdrop-blur-sm p-4 rounded-lg shadow-lg border border-white/20">
                <AspectRatio ratio={16/9}>
                  <iframe
                    className="w-full h-full rounded-lg shadow-lg border-2 border-white/40"
                    src={videoUrl}
                    title="Unheilig - Ein großes Leben"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                    allowFullScreen
                  />
                </AspectRatio>
              </div>
            </div>
          </div>


          {/* NS7 Challenge Button - exact copy from NS7 */}
          <div className="flex justify-center mb-8">
            <button 
              onClick={() => navigate('/alle-infos')}
              className="bg-white/10 hover:bg-white/20 text-white border-2 border-[#ECA505] px-4 py-1.5 rounded-lg text-sm font-semibold transition-all cursor-pointer flex items-center gap-2"
            >
              Du hast Lust und bist bereit für diese Challenge? <div className="flex items-center">
                <ChevronRight className="w-4 h-4" />
                <ChevronRight className="w-4 h-4 -ml-2" />
              </div>
            </button>
          </div>

          <div className="flex justify-center mt-8">
            <Button 
              variant="ghost" 
              className="text-white hover:bg-white/10 p-2 h-auto group"
              onClick={handleNavigateBack}
            >
              <div className="flex items-center animate-horizontal-bounce">
                <ChevronLeft className="w-4 h-4" />
                <ChevronLeft className="w-4 h-4 -ml-2" />
              </div>
              <span className="ml-2">Zurück</span>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SommerCamps2025Page;